<template>
  <div class="pageMove" v-if="pageOption.pageTotal>pageOption.pageSize">
    <a @click="pageF(1)">首页</a>
    <a @click="pageF(pageOption.pageIndex-1<1?1:pageOption.pageIndex-1)">上一页</a>
    <a
      @click="pageF(pageOption.pageIndex-2)"
      v-show="!(pageOption.pageIndex-2<2)"
    >{{ pageOption.pageIndex-2 }}</a>
    <a
      @click="pageF(pageOption.pageIndex-1)"
      v-show="!(pageOption.pageIndex-1<1)"
    >{{ pageOption.pageIndex-1 }}</a>
    <a @click="pageF(pageOption.pageIndex)" class="on">{{ pageOption.pageIndex }}</a>
    <a
      @click="pageF(pageOption.pageIndex+1)"
      v-show="!(pageOption.pageIndex+1>pageOption.allPage)"
    >{{ pageOption.pageIndex+1 }}</a>
    <a
      @click="pageF(pageOption.pageIndex+2)"
      v-show="!(pageOption.pageIndex+2>=pageOption.allPage+1)"
    >{{ pageOption.pageIndex+2 }}</a>
    <a
      @click="pageF(pageOption.pageIndex+1>pageOption.allPage?pageOption.allPage:pageOption.pageIndex+1)"
    >下一页</a>
    <a @click="pageF(pageOption.allPage)">尾页</a>
  </div>
</template>

<script>
export default {
  name: "pageMove",
  data() {
    return {
      page: {
        index: 1
      }
    };
  },
  props: ["pageOption"],
  created() {
    setTimeout(()=>{
      this.pageOption.allPage = Math.ceil(
      this.pageOption.pageTotal / this.pageOption.pageSize
    );
    },100)
  },
  methods: {
    pageF(i) {
      this.$emit("pageindex", i);
    }
  }
};
</script>

<style>
.pageMove {
  text-align: center;
  margin: 0px auto;
}

.pageMove a {
  cursor: pointer;
  font-size: 22px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 1px;
  color: #333333;
  margin: 0 15px;
}

.pageMove a.on {
  color: #01587d;
}
</style>



// WEBPACK FOOTER //
// src/components/pageMove/pageMove.vue